import { render } from "./SnippetFooter.vue?vue&type=template&id=007ae910&scoped=true"
import script from "./SnippetFooter.vue?vue&type=script&lang=js"
export * from "./SnippetFooter.vue?vue&type=script&lang=js"

import "./SnippetFooter.vue?vue&type=style&index=0&id=007ae910&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007ae910"]])

export default __exports__